// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer-module--footer--1M7a8","cta":"Footer-module--cta--2tobg","shamrock":"Footer-module--shamrock--34Hbn","dimmed":"Footer-module--dimmed--2MKUP"};